// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

.supportTicketPopupWindow {
  position: fixed;
  z-index: 1300;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--popupBackgroundColor);
  display: flex;
  align-items: center;
  justify-content: center;
}
.supportTicketPopupWindow :where(.supportTicketSavePopup) {
  background-color: var(--whiteColour);
  border-radius: 10px;
  padding: 10px 27px;
  width: 50vw;
  row-gap: 20px;
  justify-content: center;
}

.supportTicketPopupWindow .supportPopup {
  /* Firefox */
  scrollbar-width: 2px;
  /* IE and Edge */
  -ms-overflow-style: none;
}

.supportPopup::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-corner {
  display: none;
}

.supportTicketPopupWindow :where(.supportTicketSavePopup) .headerSection {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .headerSection
  .headerTitle {
  font-family: var(--default-FontName);
  font-size: var(--sub-header-FontSize);
  color: var(--default-FontColour);
  font-weight: var(--sub-header-FontWeight);
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .headerSection
  .popupCloseIcon,
.userSelectionDialogPopupContentSection .headingSection .popupCloseIcon {
  height: 18px;
  width: 18px;
  cursor: pointer;
}

.supportTicketPopupWindow .headerSection .headerTitle {
  font-size: var(--mainheading-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--header-FontWeight);
  color: var(--secondary-FontColour);
}

.supportTicketPopupWindow .supportTicketSavePopup .footerSection {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-bottom: 5px;
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .dataSection {
  justify-content: space-evenly;
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .dataSection,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .inputControls,
.supportTicketPopupWindow
  .inputControls
  .dropDown_styles
  .custom_fileuploadbutton,
.supportTicketPopupWindow
  .inputControls
  .dropzonearea
  .imageUploadCustomMessage,
.supportTicketDialogPopupMainSection .supportTicketDialogPopupContentSection,
.supportTicketPopupWindow :where(.supportTicketSavePopup) {
  display: flex;
  flex-direction: column;
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .imageUploadSection {
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .dataSection,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .imageUploadSection {
  row-gap: 10px;
}
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .inputControls {
  row-gap: 5px;
}

.supportTicketPopupWindow .autoCompleteLazyLoadctrl .controlLabelDiv,
.supportTicketPopupWindow .textbox .controlLabelDiv,
.contract_InputLabel,
.userSelectionDialogPopupContentSection
  .autoCompleteLazyLoadctrl
  .controlLabelDiv {
  font-family: var(--default-FontName);
  font-size: var(--label-FontSize);
  color: var(--label-FontColour);
  font-weight: var(--sub-header-FontWeight);
  gap: 1px;
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .textbox
  .MuiInputBase-root,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .commonContentSection
  .autoCompleteLazyLoadinputDiv,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .commonContentSection
  .autoCompleteLazyLoadinputDiv
  .autoCompleteInput,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .dateandtimepickers
  .multidateandtime-container,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .dateandtimepickers
  .multidateandtime-container
  .multidateandtimeinput {
  background-color: var(--inputControlBackgroundColor);
}
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .MuiInputBase-root,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .commonContentSection
  .autoCompleteLazyLoadinputDiv,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .dateTimePickerInputDiv {
  border: var(--inputControlBorderSize) var(--inputControlBorderColor) solid;
}
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .commonContentSection
  .mandatorySymbol {
  color: var(--mandatorySymbol);
}

.supportTicketPopupWindow
  .supportTicketSavePopup
  .textbox
  .MuiFormHelperText-root {
  margin-top: -10px;
}
.supportTicketPopupWindow
  .supportTicketSavePopup
  .textbox
  .outlineError
  .MuiInputBase-root {
  border: 1px solid var(--required-color);
  border-radius: 4px;
}

.supportPopup .imageContainer .MuiSvgIcon-root {
  display: block !important;
}

@media (min-width: 1000px) and (max-width: 1250px) {
  .supportTicketPopupWindow :where(.supportTicketSavePopup) {
    width: 75vw;
  }

  .supportTicketPopupWindow
    .supportTicketSavePopup
    .multidateandtime-container.dateTimePickerInputDiv {
    margin-bottom: -4px;
  }

  .supportPopup .imageContainer .MuiSvgIcon-root {
    width: 1rem;
    height: 1rem;
  }
}
@media (min-width: 1251px) and (max-width: 1650px) {
  .supportTicketPopupWindow
    .supportTicketSavePopup
    .multidateandtime-container.dateTimePickerInputDiv {
    margin-bottom: -4px;
  }

  .supportTicketPopupWindow :where(.supportTicketSavePopup) {
    width: 70vw;
  }

  .supportPopup .imageContainer .MuiSvgIcon-root {
    width: 1rem;
    height: 1rem;
  }
}

.supportPopup .imagecontainerMainSection {
  padding-bottom: 10px;
  overflow: auto;
  height: 95%;
}

@media (min-width: 1550px) and (max-width: 1650px) {
  .supportTicketPopupWindow
    .supportTicketSavePopup
    .multidateandtime-container.dateTimePickerInputDiv {
    margin-bottom: -2px;
  }
}

.supportTicketPopupWindow
  .supportTicketSavePopup
  .dateandtimepickers.outlineError
  .dateTimePickerInputDiv {
  border: 1px solid var(--required-color) !important;
  border-radius: 4px;
}

.btn_location_register .btn--primary.button.MuiButton-root {
  min-width: 75px !important;
}

.supportTicketSavePopup .commonContentSection .autoCompleteLazyLoadinputDiv {
  height: 37px;
}

.inputWarningDate .textbox .MuiFormControl-root .MuiInputBase-root {
  background-color: var(--gridbgcolor);
}

.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .locationWarningEndDate
  .dateandtimepickers
  .multidateandtime-container,
.supportTicketPopupWindow
  :where(.supportTicketSavePopup)
  .contentSection
  .locationWarningEndDate
  .dateandtimepickers
  .multidateandtime-container
  .multidateandtimeinput {
  background-color: var(--gridbgcolor);
}

.supportTicketPopupWindow .commonContentSection {
  overflow: hidden;
  height: 502px;
}

#supportTicketPopupWindow .supportTicketSavePopup,
.supportTicketPopupWindow .contentSection,
#supportTicketSavePopup .supportTicketContentMainsection {
  height: 100%;
}

.supportTicketPopupWindow .inputControls textarea {
  width: 100%;
}

.supportTicketPopupWindow .inputControls textarea {
  background-color: var(--whiteColour);
  border-color: var(--inputControlBorderColor);
  resize: none;
}

.supportTicketPopupWindow .inputControls .dropDown_styles {
  height: 115px;
  justify-content: center;
}

.supportTicketPopupWindow
  .inputControls
  .dropDown_styles
  .custom_fileuploadbutton {
  align-items: center;
  justify-content: center;
  position: unset;
  margin-left: unset;
  margin-top: -2.25%;
  row-gap: 5px;
}

.supportTicketPopupWindow .inputControls .dropzonearea .customContent {
  display: none;
}

.supportTicketPopupWindow .inputControls .dropzonearea {
  border-radius: 10px;
  background-color: var(--appcontent-bg-color);
}

.supportTicketPopupWindow
  .inputControls
  .dropzonearea
  .imageUploadCustomMessage {
  flex-wrap: nowrap;
  align-items: center;
  row-gap: 5px;
}

.supportTicketPopupWindow
  .inputControls
  .dropzonearea
  .imageUploadCustomMessage
  .mainText {
  font-weight: var(--header-FontWeight);
}

.supportTicketPopupWindow
  .inputControls
  .dropzonearea
  .imageUploadCustomMessage
  .subText {
  color: var(--default-FontColour);
}

.supportTicketPopupWindow .inputControls .imageContainer,
.supportTicketPopupWindow .inputControls .imageContainer .imageSection {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.supportTicketPopupWindow .inputControls .imageContainer .imageSection {
  column-gap: 5px;
}

.supportTicketPopupWindow .inputControls .imageContainer .imageSection img {
  width: 20px;
  height: 20px;
}

.supportTicketPopupWindow
  .inputControls
  .imageContainer
  .imageSection
  .uploadImageName {
  font-size: var(--tooltipFontSize);
}

.supportTicketPopupWindow .inputControls .imageContainer {
  justify-content: space-between;
  padding: 5px 10px;
  border: 1px solid var(--inputControlBorderColor);
  border-radius: 5px;
  height: fit-content;
}

.supportTicketPopupWindow
  .inputControls
  .imageContainer
  .uploadImageRemove
  svg {
  font-size: var(--buttonIconSize);
}

.supportTicketPopupWindow .inputControls .imageContainer .uploadImageRemove {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.supportPopup .supportTicketSavePopup {
  /* Firefox */
  scrollbar-width: thin;
  /* IE and Edge */
  -ms-overflow-style: none;
}

.supportTicketDialogPopupMainSection .supportTicketHeading {
  font-size: var(--dialogTitleFontSize);
  font-weight: var(--dialogTitleFontWeight);
}

.supportTicketDialogPopupMainSection .supportTicketDialogPopupContentSection {
  align-items: center;
  justify-content: center;
  row-gap: 15px;
}

.supportTicketDialogPopupMainSection .MuiPaper-root button {
  padding: 0 50px !important;
  height: 30px;
}
.supportTicketDialogPopupMainSection
  .supportTicketDialogPopupContentSection
  img {
  width: 45px;
}

.supportTicketDialogPopupMainSection .MuiPaper-root {
  justify-items: center;
  max-width: 24%;
}

.supportTicket.autoCompleteLazyLoadPopper {
  z-index: 1301 !important;
}

#supportTicketSavePopup .supportTicketContentMainsection {
  display: grid;
  column-gap: 1vw;
  grid-template-columns: 1fr 1fr;
  align-items: flex-start;
}

#supportTicketSavePopup .imageUploadSection .haloSupportImagesMainSection,
.supportTicketPopupWindow .inputControls .imageContainer {
  margin-right: 5px;
}

#supportTicketPopupWindow
  .supportTicketContentMainsection
  .inputControls
  .messageContainer {
  float: left;
  margin-top: -3px;
}

#supportTicketPopupWindow
  .supportTicketContentMainsection
  .inputControls
  .messageContainer
  .errorMessageText {
  font-size: var(--fieldAlertFontSize);
}

.userSelectionDialogPopupMainSection .MuiPaper-root.MuiPaper-elevation {
  width: 500px !important;
}

.userSelectionDialogPopupMainSection
  .MuiPaper-root.MuiPaper-elevation
  .userSelectionDialogPopupContentSection {
  display: flex;
  flex-direction: column;
  row-gap: 35px;
}

.userSelectionDialogPopupMainSection
  .MuiPaper-root.MuiPaper-elevation
  .userSelectionDialogPopupContentSection
  .headingSection {
  font-size: var(--gridTitleFontSize);
  font-weight: var(--listHeaderFontWeight);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.autoCompleteLazyLoadPopper.userSelection {
  z-index: 2009 !important;
}

.userSelectionDialogPopupMainSection
  .MuiDialog-container
  .MuiDialogContent-root {
  padding: 7px !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/home/HaloSupportTicket.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;EAIE,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,aAAa;AACf;AACA;;;;EAIE,YAAY;AACd;;AAEA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,yCAAyC;EACzC,QAAQ;AACV;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,oDAAoD;AACtD;AACA;;;;;;;;;;;;EAYE,0EAA0E;AAC5E;AACA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,iBAAiB;AACnB;AACA;;;;;EAKE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;AACb;;AAEA;EACE;;;IAGE,mBAAmB;EACrB;AACF;;AAEA;;;;EAIE,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;;EAaE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;;;;EAIE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;;EAKE,qCAAqC;AACvC;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;AACA;;;EAGE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;;;;EAIE,mCAAmC;EACnC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,uBAAuB;AACzB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n.supportTicketPopupWindow {\n  position: fixed;\n  z-index: 1300;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: var(--popupBackgroundColor);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.supportTicketPopupWindow :where(.supportTicketSavePopup) {\n  background-color: var(--whiteColour);\n  border-radius: 10px;\n  padding: 10px 27px;\n  width: 50vw;\n  row-gap: 20px;\n  justify-content: center;\n}\n\n.supportTicketPopupWindow .supportPopup {\n  /* Firefox */\n  scrollbar-width: 2px;\n  /* IE and Edge */\n  -ms-overflow-style: none;\n}\n\n.supportPopup::-webkit-scrollbar {\n  width: 0px;\n}\n\n::-webkit-scrollbar-corner {\n  display: none;\n}\n\n.supportTicketPopupWindow :where(.supportTicketSavePopup) .headerSection {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .headerSection\n  .headerTitle {\n  font-family: var(--default-FontName);\n  font-size: var(--sub-header-FontSize);\n  color: var(--default-FontColour);\n  font-weight: var(--sub-header-FontWeight);\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .headerSection\n  .popupCloseIcon,\n.userSelectionDialogPopupContentSection .headingSection .popupCloseIcon {\n  height: 18px;\n  width: 18px;\n  cursor: pointer;\n}\n\n.supportTicketPopupWindow .headerSection .headerTitle {\n  font-size: var(--mainheading-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--header-FontWeight);\n  color: var(--secondary-FontColour);\n}\n\n.supportTicketPopupWindow .supportTicketSavePopup .footerSection {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  padding-bottom: 5px;\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .dataSection {\n  justify-content: space-evenly;\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .dataSection,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .inputControls,\n.supportTicketPopupWindow\n  .inputControls\n  .dropDown_styles\n  .custom_fileuploadbutton,\n.supportTicketPopupWindow\n  .inputControls\n  .dropzonearea\n  .imageUploadCustomMessage,\n.supportTicketDialogPopupMainSection .supportTicketDialogPopupContentSection,\n.supportTicketPopupWindow :where(.supportTicketSavePopup) {\n  display: flex;\n  flex-direction: column;\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .imageUploadSection {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  overflow: hidden;\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .dataSection,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .imageUploadSection {\n  row-gap: 10px;\n}\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .inputControls {\n  row-gap: 5px;\n}\n\n.supportTicketPopupWindow .autoCompleteLazyLoadctrl .controlLabelDiv,\n.supportTicketPopupWindow .textbox .controlLabelDiv,\n.contract_InputLabel,\n.userSelectionDialogPopupContentSection\n  .autoCompleteLazyLoadctrl\n  .controlLabelDiv {\n  font-family: var(--default-FontName);\n  font-size: var(--label-FontSize);\n  color: var(--label-FontColour);\n  font-weight: var(--sub-header-FontWeight);\n  gap: 1px;\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .textbox\n  .MuiInputBase-root,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .commonContentSection\n  .autoCompleteLazyLoadinputDiv,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .commonContentSection\n  .autoCompleteLazyLoadinputDiv\n  .autoCompleteInput,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .dateandtimepickers\n  .multidateandtime-container,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .dateandtimepickers\n  .multidateandtime-container\n  .multidateandtimeinput {\n  background-color: var(--inputControlBackgroundColor);\n}\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .MuiInputBase-root,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .commonContentSection\n  .autoCompleteLazyLoadinputDiv,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .dateTimePickerInputDiv {\n  border: var(--inputControlBorderSize) var(--inputControlBorderColor) solid;\n}\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .commonContentSection\n  .mandatorySymbol {\n  color: var(--mandatorySymbol);\n}\n\n.supportTicketPopupWindow\n  .supportTicketSavePopup\n  .textbox\n  .MuiFormHelperText-root {\n  margin-top: -10px;\n}\n.supportTicketPopupWindow\n  .supportTicketSavePopup\n  .textbox\n  .outlineError\n  .MuiInputBase-root {\n  border: 1px solid var(--required-color);\n  border-radius: 4px;\n}\n\n.supportPopup .imageContainer .MuiSvgIcon-root {\n  display: block !important;\n}\n\n@media (min-width: 1000px) and (max-width: 1250px) {\n  .supportTicketPopupWindow :where(.supportTicketSavePopup) {\n    width: 75vw;\n  }\n\n  .supportTicketPopupWindow\n    .supportTicketSavePopup\n    .multidateandtime-container.dateTimePickerInputDiv {\n    margin-bottom: -4px;\n  }\n\n  .supportPopup .imageContainer .MuiSvgIcon-root {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n@media (min-width: 1251px) and (max-width: 1650px) {\n  .supportTicketPopupWindow\n    .supportTicketSavePopup\n    .multidateandtime-container.dateTimePickerInputDiv {\n    margin-bottom: -4px;\n  }\n\n  .supportTicketPopupWindow :where(.supportTicketSavePopup) {\n    width: 70vw;\n  }\n\n  .supportPopup .imageContainer .MuiSvgIcon-root {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n\n.supportPopup .imagecontainerMainSection {\n  padding-bottom: 10px;\n  overflow: auto;\n  height: 95%;\n}\n\n@media (min-width: 1550px) and (max-width: 1650px) {\n  .supportTicketPopupWindow\n    .supportTicketSavePopup\n    .multidateandtime-container.dateTimePickerInputDiv {\n    margin-bottom: -2px;\n  }\n}\n\n.supportTicketPopupWindow\n  .supportTicketSavePopup\n  .dateandtimepickers.outlineError\n  .dateTimePickerInputDiv {\n  border: 1px solid var(--required-color) !important;\n  border-radius: 4px;\n}\n\n.btn_location_register .btn--primary.button.MuiButton-root {\n  min-width: 75px !important;\n}\n\n.supportTicketSavePopup .commonContentSection .autoCompleteLazyLoadinputDiv {\n  height: 37px;\n}\n\n.inputWarningDate .textbox .MuiFormControl-root .MuiInputBase-root {\n  background-color: var(--gridbgcolor);\n}\n\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .locationWarningEndDate\n  .dateandtimepickers\n  .multidateandtime-container,\n.supportTicketPopupWindow\n  :where(.supportTicketSavePopup)\n  .contentSection\n  .locationWarningEndDate\n  .dateandtimepickers\n  .multidateandtime-container\n  .multidateandtimeinput {\n  background-color: var(--gridbgcolor);\n}\n\n.supportTicketPopupWindow .commonContentSection {\n  overflow: hidden;\n  height: 502px;\n}\n\n#supportTicketPopupWindow .supportTicketSavePopup,\n.supportTicketPopupWindow .contentSection,\n#supportTicketSavePopup .supportTicketContentMainsection {\n  height: 100%;\n}\n\n.supportTicketPopupWindow .inputControls textarea {\n  width: 100%;\n}\n\n.supportTicketPopupWindow .inputControls textarea {\n  background-color: var(--whiteColour);\n  border-color: var(--inputControlBorderColor);\n  resize: none;\n}\n\n.supportTicketPopupWindow .inputControls .dropDown_styles {\n  height: 115px;\n  justify-content: center;\n}\n\n.supportTicketPopupWindow\n  .inputControls\n  .dropDown_styles\n  .custom_fileuploadbutton {\n  align-items: center;\n  justify-content: center;\n  position: unset;\n  margin-left: unset;\n  margin-top: -2.25%;\n  row-gap: 5px;\n}\n\n.supportTicketPopupWindow .inputControls .dropzonearea .customContent {\n  display: none;\n}\n\n.supportTicketPopupWindow .inputControls .dropzonearea {\n  border-radius: 10px;\n  background-color: var(--appcontent-bg-color);\n}\n\n.supportTicketPopupWindow\n  .inputControls\n  .dropzonearea\n  .imageUploadCustomMessage {\n  flex-wrap: nowrap;\n  align-items: center;\n  row-gap: 5px;\n}\n\n.supportTicketPopupWindow\n  .inputControls\n  .dropzonearea\n  .imageUploadCustomMessage\n  .mainText {\n  font-weight: var(--header-FontWeight);\n}\n\n.supportTicketPopupWindow\n  .inputControls\n  .dropzonearea\n  .imageUploadCustomMessage\n  .subText {\n  color: var(--default-FontColour);\n}\n\n.supportTicketPopupWindow .inputControls .imageContainer,\n.supportTicketPopupWindow .inputControls .imageContainer .imageSection {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.supportTicketPopupWindow .inputControls .imageContainer .imageSection {\n  column-gap: 5px;\n}\n\n.supportTicketPopupWindow .inputControls .imageContainer .imageSection img {\n  width: 20px;\n  height: 20px;\n}\n\n.supportTicketPopupWindow\n  .inputControls\n  .imageContainer\n  .imageSection\n  .uploadImageName {\n  font-size: var(--tooltipFontSize);\n}\n\n.supportTicketPopupWindow .inputControls .imageContainer {\n  justify-content: space-between;\n  padding: 5px 10px;\n  border: 1px solid var(--inputControlBorderColor);\n  border-radius: 5px;\n  height: fit-content;\n}\n\n.supportTicketPopupWindow\n  .inputControls\n  .imageContainer\n  .uploadImageRemove\n  svg {\n  font-size: var(--buttonIconSize);\n}\n\n.supportTicketPopupWindow .inputControls .imageContainer .uploadImageRemove {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.supportPopup .supportTicketSavePopup {\n  /* Firefox */\n  scrollbar-width: thin;\n  /* IE and Edge */\n  -ms-overflow-style: none;\n}\n\n.supportTicketDialogPopupMainSection .supportTicketHeading {\n  font-size: var(--dialogTitleFontSize);\n  font-weight: var(--dialogTitleFontWeight);\n}\n\n.supportTicketDialogPopupMainSection .supportTicketDialogPopupContentSection {\n  align-items: center;\n  justify-content: center;\n  row-gap: 15px;\n}\n\n.supportTicketDialogPopupMainSection .MuiPaper-root button {\n  padding: 0 50px !important;\n  height: 30px;\n}\n.supportTicketDialogPopupMainSection\n  .supportTicketDialogPopupContentSection\n  img {\n  width: 45px;\n}\n\n.supportTicketDialogPopupMainSection .MuiPaper-root {\n  justify-items: center;\n  max-width: 24%;\n}\n\n.supportTicket.autoCompleteLazyLoadPopper {\n  z-index: 1301 !important;\n}\n\n#supportTicketSavePopup .supportTicketContentMainsection {\n  display: grid;\n  column-gap: 1vw;\n  grid-template-columns: 1fr 1fr;\n  align-items: flex-start;\n}\n\n#supportTicketSavePopup .imageUploadSection .haloSupportImagesMainSection,\n.supportTicketPopupWindow .inputControls .imageContainer {\n  margin-right: 5px;\n}\n\n#supportTicketPopupWindow\n  .supportTicketContentMainsection\n  .inputControls\n  .messageContainer {\n  float: left;\n  margin-top: -3px;\n}\n\n#supportTicketPopupWindow\n  .supportTicketContentMainsection\n  .inputControls\n  .messageContainer\n  .errorMessageText {\n  font-size: var(--fieldAlertFontSize);\n}\n\n.userSelectionDialogPopupMainSection .MuiPaper-root.MuiPaper-elevation {\n  width: 500px !important;\n}\n\n.userSelectionDialogPopupMainSection\n  .MuiPaper-root.MuiPaper-elevation\n  .userSelectionDialogPopupContentSection {\n  display: flex;\n  flex-direction: column;\n  row-gap: 35px;\n}\n\n.userSelectionDialogPopupMainSection\n  .MuiPaper-root.MuiPaper-elevation\n  .userSelectionDialogPopupContentSection\n  .headingSection {\n  font-size: var(--gridTitleFontSize);\n  font-weight: var(--listHeaderFontWeight);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.autoCompleteLazyLoadPopper.userSelection {\n  z-index: 2009 !important;\n}\n\n.userSelectionDialogPopupMainSection\n  .MuiDialog-container\n  .MuiDialogContent-root {\n  padding: 7px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
